module.exports = __webpack_public_path__ + "media/images/android-chrome-192x192-55c0f4081175ad9cb6f88423d56c6555.png";